





























































import { Vue, Component } from 'vue-property-decorator';
import TicketRangeSelector from './produce-selector.vue';
import * as api from '@/api';

interface Task {
    taskId: string;
    createTime: string;
    creatorMisId: string;
    ticketCount: number;
    taskStatus: string;
    queryFilter: {
        [key: string]: string;
    };
}

@Component({
    components: {
        TicketRangeSelector
    }
})
export default class ProducePage extends Vue {
    loading: boolean = false;
    taskList: Task[] = [];
    taskTotal: number = 0;
    currentPage: number = 1;
    pageSize: number = 10;
    detailModalVisible: boolean = false;
    currentTask: any = null;
    scope?: any;

    created() {
        this.fetchTaskList();
    }

    /**
     * 获取任务列表
     */
    async fetchTaskList() {
        this.loading = true;
        try {
            const res = await api.ticketApi.getAISummaryTaskList({
                cn: this.currentPage,
                sn: this.pageSize,
                rgId: this.rgId
            });
            if (res.code === 200) {
                this.taskList = res.data.items || [];
                this.taskTotal = res.data.tn || 0;
            }
        } catch (error) {
            console.error('获取任务列表失败:', error);
            this.$mtd.message({
                type: 'error',
                message: '获取任务列表失败'
            });
        } finally {
            this.loading = false;
        }
    }

    /**
     * 处理 AI 总结提交成功
     */
    handleSummarySubmitted(taskData: any) {
        console.log('AI总结任务已提交:', taskData);
        this.currentPage = 1;
        this.fetchTaskList();
    }

    /**
     * 处理分页变化
     */
    handlePageChange() {
        this.fetchTaskList();
    }

    /**
     * 获取筛选条件标签
     */
    getFilterLabel(key: string): string {
        const labelMap: { [key: string]: string } = {
            ctiFullName: '服务目录',
            labels: '标签',
            createdAtStart: '工单开始时间',
            createdAtEnd: '工单结束时间',
            assigned: '处理人',
            archives: '问题分类',
            state: '状态'
        };
        return labelMap[key] || '';
    }

    /**
     * 查看总结结果
     */
    handleViewSummary(task: Task) {
        window.location.href = `/rg/detail/knowledge/calibration?rgId=${this.rgId}&taskId=${task.taskId}`;
    }

    /**
     * 获取状态标签
     */
    getStatusLabel(status: string): string {
        const statusMap: { [key: string]: string } = {
            CREATED: '已创建',
            PROCESSING: '进行中',
            SUCCESS: '已完成',
            FAILED: '任务失败'
        };
        return statusMap[status] || status;
    }

    /**
     * 获取状态类型
     */
    getStatusType(status: string): string {
        const typeMap: { [key: string]: string } = {
            CREATED: 'orange',
            PROCESSING: 'blue',
            SUCCESS: 'green',
            FAILED: 'red'
        };
        return typeMap[status] || 'info';
    }

    /**
     * 获取RG ID
     */
    get rgId() {
        return parseInt(this.$route.query.rgId as string, 10);
    }
}
